import React, { useState } from "react";
import './ForgotPassword.css'
import {
    ResetPasswordCall
} from './Requests';
import {PulseLoader } from "react-spinners";
import {Icon} from 'react-icons-kit';
import {eyeOff} from 'react-icons-kit/feather/eyeOff';
import {eye} from 'react-icons-kit/feather/eye'

  const ResetPassword = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const tokendFromUrlParam = queryParameters.get("token")
    const [token, setToken] = useState(tokendFromUrlParam)
    const [newPassword, setNewPassword] = useState()
    const [confirmPassword, setConfirmPassword] = useState()
    const [resetPasswordButton, setResetPasswordButton] = useState(false)
    const [passwordError, setPasswordError] = useState("")
    const [passwordResetState, setPasswordResetState] = useState("reset password")
    const [isLoading, setIsLoading] = useState(false)
    const [newPasswordIcon, setNewPasswordIcon] = useState(eyeOff)
    const [newPasswordTwoIcon, setNewPasswordTwoIcon] = useState(eyeOff)
    const [newPasswordType, setNewPasswordType] = useState('password');
    const [newPasswordTwoType, setNewPasswordTwoType] = useState('password');

    function NewPasswordHandler(e) {
        setNewPassword(e.target.value)
        if (e.target.value === "" || e.target.value === undefined || e.target.value === null || confirmPassword === "" || confirmPassword === undefined || confirmPassword === null)
        {
            setResetPasswordButton(false)
        }
        else
        {
            setResetPasswordButton(true)
        }
      }

      function ConfirmPasswordHandler(e) {
        setConfirmPassword(e.target.value)
        if (e.target.value === "" || e.target.value === undefined || e.target.value === null || newPassword === "" || newPassword === undefined || newPassword === null)
        {
            setResetPasswordButton(false)
        }
        else
        {
            setResetPasswordButton(true)
        }
      }

      function ResetButtonClicked()
      {
        setPasswordError("")
        if (newPassword !== confirmPassword)
        {
            setPasswordError("Passwords do not match")
        }
        else
        {
            if (newPassword.length < 8)
            {
                setPasswordError("Password needs to be atleast 8 characters")
            }
            else
            {
                setPasswordError("")
                setIsLoading(true)
                ResetPasswordCall(newPassword, token).then((res) => {
                if (res.status === 200)
                {
                    setPasswordResetState("success")
                    setIsLoading(false)
                }
            }).catch((error) => {
                setPasswordResetState("error")
                setIsLoading(false)
            })
            }
        }
      }

    function handlePasswordIconToggle(passwordBox)
    {    
    if (passwordBox === "newPassword")
        {
        if (newPasswordType === "password")
            {
            setNewPasswordType('text')
            setNewPasswordIcon(eye)
            }
            else
              {
                setNewPasswordType('password')
                setNewPasswordIcon(eyeOff)
              }
          }
      
        if (passwordBox === "newPasswordTwo")
          {
            if (newPasswordTwoType === "password")
              {
                setNewPasswordTwoType('text')
                setNewPasswordTwoIcon(eye)
              }
              else
              {
                setNewPasswordTwoType('password')
                setNewPasswordTwoIcon(eyeOff)
              }
          }
        }
  
    return (
      <div>
        {token !== null ?
        <div className="request-forgot-password-container">
            <div className="request-forgot-password-card">
                <PulseLoader 
                    color={'#333'}
                    loading={isLoading}
                    size={25}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
                {passwordResetState === "reset password" && !isLoading?
                <div>
                    <h1>Reset Password</h1>
                    <div style={{width:"80%", marginLeft:"auto", marginRight:"auto"}}>
                        <div style={{display:"flex"}}>
                            <label htmlFor="">New Password</label>
                        </div>
                        <input className="reset-password-input" type={newPasswordType} onChange={(e) => {NewPasswordHandler(e)}} id="" placeholder="new password" />
                        <Icon className="reset-password-eye-icon" icon={newPasswordIcon} size={20} onClick={(e) => {handlePasswordIconToggle("newPassword")}}/>
                        <div style={{display:"flex"}}>
                            <label htmlFor="">Confirm Password</label>
                        </div>
                        <input className="reset-password-input" type={newPasswordTwoType} onChange={(e) => {ConfirmPasswordHandler(e)}} id="" placeholder="confirm password" />
                        <Icon className="reset-password-eye-icon" icon={newPasswordTwoIcon} size={20} onClick={(e) => {handlePasswordIconToggle("newPasswordTwo")}}/>
                    </div>
                    <p style={{color:"red"}}>{passwordError}</p>
                    <button onClick={ResetButtonClicked} disabled={!resetPasswordButton} className={resetPasswordButton ? "reset-button": "disabled-reset-button"}>Reset Password</button>
                </div>
                :
                passwordResetState === "error" && !isLoading
                ?
                <div>
                    <h1>Oh No!</h1>
                    <p>There was an issue resetting your password, please try again or contact support.</p>
                </div>
                :
                passwordResetState === "success" && !isLoading
                ?
                <div>
                    <h1>Hooray!</h1>
                    <p>Password has been changed</p>
                    <a href={process.env.REACT_APP_CLIENT_BASE_URL+"login"}><button className="reset-button">Login</button></a>
                </div>
                
                :
                <div>
                </div>
            }

            </div>
        </div>
        :
        <div>
        </div>
  }
      </div>
    );
  };
  
  export default ResetPassword;